import { useEffect } from 'react'
import { throttle } from 'lodash'
import { useStore } from '../../../models'

export const usePreFold = () => {
  const {
    game: { isMyTurn, hasUserPreFold, setHasUserPreFold, doFoldForPlayer }
  } = useStore()

  const doFold = throttle(async () => {
    setHasUserPreFold(false)
    await doFoldForPlayer()
  }, 1000)

  useEffect(() => {
    if (isMyTurn && hasUserPreFold) {
      doFold()
    }
  }, [isMyTurn, hasUserPreFold, doFold])
}
